import React, { useEffect, useState } from "react";
import Heading from "../components/atoms/Heading";
import AccesosDirectos from "../components/organisms/dashboard/AccesosDirectos";
import { useSession } from "../context/SessionContext";
import SubHeading from "../components/atoms/SubHeading";
import { GET_ENTERPRISES } from "../api/apiEmpresas";
import LogosDashboard from "../components/molecules/dashboard/LogosDashboard";
import CardHeader from "../components/atoms/CardHeader";

const Dashboard = () => {
    const { user } = useSession();
    const [empresas, setEmpresas] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getEnterprises = async () => {
            try {
                setLoading(true);
                const enterprisesData = await GET_ENTERPRISES();
                setEmpresas(enterprisesData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getEnterprises();
    }, []);

    const handleGoWebsite = () => {
        const newTab = window.open("http://ramirezsoto.com.mx/", "_blank", "noopener, noreferrer");
        if (newTab) newTab.opener = null;
    };

    return(
        <div className="space-y-4">
            <CardHeader>
                <Heading text={`¡Bienvenido! ${user?.roleInfo?.name || "Cargando..."} `} color="red" />
                <div className="flex flex-row space-x-1">
                    <SubHeading text="Visita:" color="blue"/>
                    <SubHeading text="Ramírez Soto" link color="blue" onClick={()=>handleGoWebsite()} />
                </div>
            </CardHeader>
            <LogosDashboard/>
            <AccesosDirectos data={empresas} loading={loading} />
        </div>
    )
};

export default Dashboard;